import React from 'react';
import { Clock } from 'lucide-react';
import { DaySchedule, GLOBAL_PHONE } from '../../data/locations';
interface LocationScheduleProps {
  schedule?: DaySchedule[];
  hasSchedule: boolean;
  locationName: string;
}
export function LocationSchedule({
  schedule,
  hasSchedule,
  locationName
}: LocationScheduleProps) {
  if (!hasSchedule) {
    return <section id="schedule-section" className="py-16 bg-slate-50" data-id="element-611">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-612">
          <div className="text-center mb-8" data-id="element-613">
            <div className="inline-flex items-center justify-center p-3 bg-white rounded-full mb-4" data-id="element-614">
              <Clock className="h-6 w-6 text-[#dc2626]" data-id="element-615" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-616">
              Class Schedule
            </h2>
          </div>

          <div className="max-w-2xl mx-auto bg-white rounded-xl border border-slate-200 shadow-sm p-8 text-center" data-id="element-617">
            <h3 className="text-xl font-bold text-[#1a2332] mb-4" data-id="element-618">
              Schedule Coming Soon
            </h3>
            <p className="text-slate-600 mb-6" data-id="element-619">
              We're currently finalizing the class schedule for {locationName}.
            </p>
            <p className="text-slate-700 font-medium" data-id="element-620">
              Call or text{' '}
              <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="text-[#dc2626] hover:text-[#b91c1c] transition-colors" data-id="element-621">
                {GLOBAL_PHONE}
              </a>{' '}
              for current class times.
            </p>
          </div>
        </div>
      </section>;
  }
  return <section id="schedule-section" className="py-16 bg-slate-50" data-id="element-622">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-623">
        <div className="text-center mb-12" data-id="element-624">
          <div className="inline-flex items-center justify-center p-3 bg-white rounded-full mb-4" data-id="element-625">
            <Clock className="h-6 w-6 text-[#dc2626]" data-id="element-626" />
          </div>
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-627">
            Class Schedule
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-628">
            All classes are included in your membership. Drop in to any class
            that fits your schedule.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-629">
          {schedule?.map((day, index) => <div key={index} className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-630">
              <h3 className="text-lg font-bold text-[#1a2332] mb-4 pb-3 border-b border-slate-200" data-id="element-631">
                {day.day}
              </h3>
              <div className="space-y-3" data-id="element-632">
                {day.classes.map((classItem, classIndex) => <div key={classIndex} className="text-sm" data-id="element-633">
                    <div className="font-medium text-[#dc2626] mb-1" data-id="element-634">
                      {classItem.time}
                    </div>
                    <div className="text-slate-700" data-id="element-635">{classItem.name}</div>
                  </div>)}
              </div>
            </div>)}
        </div>

        <div className="mt-8 text-center" data-id="element-636">
          <p className="text-sm text-slate-600" data-id="element-637">
            Questions about the schedule?{' '}
            <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="text-[#dc2626] hover:text-[#b91c1c] font-medium transition-colors" data-id="element-638">
              Call {GLOBAL_PHONE}
            </a>
          </p>
        </div>
      </div>
    </section>;
}